// src/data/constants.js
// NEW FILE 


// Automateit/src/data/constants.js

export const defaultColors = {
  sent: "#0B93F6", // A slightly different blue, similar to iMessage
  received: "#E5E5EA",
  text: "#000000",
  headerBg: "#F8F8F8",
  // chatBg: "#FFFFFF", // Default white background
  chatBg: "rgba(255, 255, 255, 0.85)", // White with 85% opacity for slight transparency
  svgIcon: "#000000", // Default to black for header icons
  titleText: "#000000",
};

export const voices = [
  { label: "Alloy -F", value: "alloy" },
  { label: "Echo -M", value: "echo" },
  { label: "Fable -M", value: "fable" },
  { label: "Onyx -M", value: "onyx" },
  { label: "Nova -F", value: "nova" },
  { label: "Shimmer -F", value: "shimmer" },
  { label: "Ash -M", value: "ash" },
  { label: "Ballad -M", value: "ballad" },
  { label: "Coral -F", value: "coral" },
  { label: "Sage -F", value: "sage" },
  { label: "Verse -M", value: "verse" },
];


// --- ADDED THIS SECTION ---
export const soundEffects = [
  { label: "Whoosh 1", value: "whoosh-sfx.mp3" },
  { label: "Whoosh 2", value: "fire-whoosh.mp3" },
  { label: "Whoosh 3", value: "fast-whoosh.mp3" },
  { label: "Bruh", value: "Bruh.mp3" },
  { label: "Among Us", value: "Amongus.mp3" },
  { label: "Anime Ahh", value: "anime-ahh.mp3" },
  { label: "Bone Crack", value: "bone-crack.mp3" },
  { label: "Phone Ding", value: "dingsfx.mp3" },
  { label: "Discord", value: "discord.mp3" },
  { label: "Dun Dun Dun", value: "DunDun.mp3" },
  { label: "Error", value: "error.mp3" },
  { label: "Reverb Fart", value: "fart-with-reverb.mp3" },
  { label: "iPhone Swoosh", value: "iphoneSwoosh.mp3" },
  { label: "Mac Quack", value: "mac-quack.mp3" },
  { label: "OMG Meme", value: "omgmeme.mp3" },
  { label: "Perfect Fart", value: "perfect-fart.mp3" },
  { label: "PewPew", value: "pewpew.mp3" },
  { label: "Punch", value: "punch.mp3" },
  { label: "Rizz", value: "Rizz.mp3" },
  { label: "Sad Aww", value: "SadAww.mp3" },
  { label: "Spongebob Fail", value: "spongebob-fail.mp3" },
  { label: "Few Moments Later", value: "spongfewmoments.mp3" },
  { label: "Taco Bell", value: "tacoBell.mp3" },
  { label: "Vine Boom", value: "vineboom.mp3" },
  // Add more sound effects here if needed, e.g.:
  // { label: "Error Sound", value: "error.mp3" },
  // { label: "Success Sound", value: "success.mp3" },
];
// --- END OF ADDED SECTION ---